import React, { useEffect, useState, useMemo } from "react";
import { usePcr } from "../../context/PcrContext";
import { FiRefreshCw } from "react-icons/fi";
import { useOption } from "../../context/OptionContext";
import "./ActiveContracts.css";
import { useNavigate } from "react-router-dom";
const ActiveContracts = () => {
  // const { pcrStore, loadIndexData } = usePcr();
  const [viewType, setViewType] = useState("volume");
  const [lastUpdated, setLastUpdated] = useState("");
  const {
    fetchByIndex,
    optionData,
    expiries,
    setExpiry,
    selectedExpiry,

    loading,
  } = useOption();

  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  // useEffect(() => {
  //   loadIndexData("NIFTY");

  //   setTimeout(() => {
  //     loadIndexData("BANKNIFTY");
  //     setLastUpdated(formatTimestamp());
  //   }, 1200);
  // }, []);
  useEffect(() => {
    fetchByIndex("NIFTY");
  }, []);
  useEffect(() => {
    if (expiries?.length && !selectedExpiry) {
      setExpiry(expiries[0]);
    }
  }, [expiries, selectedExpiry]);

  console.log("Option data", optionData);

  // const niftyData = pcrStore?.NIFTY;
  // const bankNiftyData = pcrStore?.BANKNIFTY;
  // console.log("NoftyData", niftyData);
  // console.log("BankNifty", bankNiftyData);
  //   function normalizeContracts(records, symbol) {
  //     if (!records || !records.data) return []; // safeguard

  //     return records.data.flatMap((item) => {
  //       const ce = item.CE
  //         ? { ...item.CE, type: "CE", strikePrice: item.strikePrice, symbol }
  //         : null;
  //       const pe = item.PE
  //         ? { ...item.PE, type: "PE", strikePrice: item.strikePrice, symbol }
  //         : null;
  //       return [ce, pe].filter(Boolean);
  //     });
  //   }
  function normalizeContracts(records, symbol) {
    if (!records || !records.data) return [];

    const currentExpiry = records.expiryDates[0];

    return records.data.flatMap((item) => {
      const ce =
        item.CE && item.CE.expiryDate === currentExpiry
          ? { ...item.CE, type: "CE", strikePrice: item.strikePrice, symbol }
          : null;
      const pe =
        item.PE && item.PE.expiryDate === currentExpiry
          ? { ...item.PE, type: "PE", strikePrice: item.strikePrice, symbol }
          : null;
      return [ce, pe].filter(Boolean);
    });
  }

  //   function addTradedValue(contracts) {
  //     contracts?.forEach((c) => {
  //       c.tradedValue = (c.lastPrice || 0) * (c.totalTradedVolume || 0);
  //     });
  //     return contracts;
  //   }
  function addTradedValue(contracts) {
    contracts?.forEach((c) => {
      // Premium turnover in ₹ Lakhs
      c.tradedValue =
        ((c.lastPrice || 0) * (c.totalTradedVolume || 0)) / 100000;
    });
    return contracts;
  }

  // const niftyContracts = addTradedValue(
  //   normalizeContracts(niftyData?.records, "NIFTY")
  // );
  // const bankContracts = addTradedValue(
  //   normalizeContracts(bankNiftyData?.records, "BANKNIFTY")
  // );

  // const allContracts = [...niftyContracts, ...bankContracts];
  // console.log("Allcontracts", allContracts);
  //   const byVolume = [...allContracts]
  //     .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
  //     .slice(0, 10);

  //   const byValue = [...allContracts]
  //     .sort((a, b) => b.tradedValue - a.tradedValue)
  //     .slice(0, 10);
  // const byVolume = [...allContracts]
  //   .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
  //   .slice(0, 10);

  // const byValue = [...allContracts]
  //   .sort((a, b) => b.tradedValue - a.tradedValue)
  //   .slice(0, 10);

  const activeContractsOptions = ["Volume", "Value"];
  // const contracts = viewType === "volume" ? byVolume : byValue;

  //refresh function
  // const handleRefresh = async () => {
  //   setLastUpdated(formatTimestamp());

  //   await Promise.all([loadIndexData("NIFTY"), loadIndexData("BANKNIFTY")]);
  // };
  // const contracts = useMemo(() => {
  //   if (!optionData?.data?.oc) return [];

  //   return Object.entries(optionData.data.oc).flatMap(([strike, obj]) => {
  //     const ce = obj.ce
  //       ? {
  //           instrument: "Index Options",
  //           underlying: "NIFTY",
  //           expiry: selectedExpiry,
  //           type: "CE",
  //           strikePrice: Number(strike),
  //           ltp: obj.ce.last_price,
  //           volume: obj.ce.volume,
  //           oi: obj.ce.oi,
  //           prevClose: obj.ce.previous_close_price,
  //         }
  //       : null;

  //     const pe = obj.pe
  //       ? {
  //           instrument: "Index Options",
  //           underlying: "NIFTY",
  //           expiry: selectedExpiry,
  //           type: "PE",
  //           strikePrice: Number(strike),
  //           ltp: obj.pe.last_price,
  //           volume: obj.pe.volume,
  //           oi: obj.pe.oi,
  //           prevClose: obj.pe.previous_close_price,
  //         }
  //       : null;

  //     return [ce, pe].filter(Boolean);
  //   });
  // }, [optionData, selectedExpiry]);
  // const enrichedContracts = useMemo(() => {
  //   return contracts.map((c) => ({
  //     ...c,
  //     tradedValue: ((c.last_price || 0) * (c.volume || 0)) / 100000, // ₹ Lakhs
  //   }));
  // }, [contracts]);
  // const byVolume = [...enrichedContracts]
  //   .sort((a, b) => b.volume - a.volume)
  //   .slice(0, 10);

  // const byValue = [...enrichedContracts]
  //   .sort((a, b) => b.tradedValue - a.tradedValue)
  //   .slice(0, 10);

  // const finalContracts = viewType === "volume" ? byVolume : byValue;
  // const mostActiveByVolume = [...enrichedContracts]
  //   .sort((a, b) => b.volume - a.volume)
  //   .slice(0, 10);

  // const mostActiveByValue = [...enrichedContracts]
  //   .sort((a, b) => b.tradedValue - a.tradedValue)
  //   .slice(0, 10);

  // const filteredContracts = useMemo(() => {
  //   return viewType === "volume" ? mostActiveByVolume : mostActiveByValue;
  // }, [viewType, mostActiveByVolume, mostActiveByValue]);
  // =====================
  // MOST ACTIVE CONTRACTS (OPTION CHAIN BASED)
  // =====================

  const contracts = useMemo(() => {
    if (!optionData?.data?.oc || !selectedExpiry) return [];

    return Object.entries(optionData.data.oc).flatMap(([strike, obj]) => {
      const buildContract = (opt, type) => {
        if (!opt) return null;

        const pChange =
          opt.previous_close_price > 0
            ? ((opt.last_price - opt.previous_close_price) /
                opt.previous_close_price) *
              100
            : 0;

        return {
          instrument: "Index Options",
          underlying: "NIFTY",
          expiry: selectedExpiry,
          type, // CE / PE
          strikePrice: Number(strike),

          lastPrice: opt.last_price,
          volume: opt.volume,
          openInterest: opt.oi,
          pChange,
        };
      };

      return [buildContract(obj.ce, "CE"), buildContract(obj.pe, "PE")].filter(
        Boolean,
      );
    });
  }, [optionData, selectedExpiry]);

  const enrichedContracts = useMemo(() => {
    return contracts.map((c) => ({
      ...c,
      tradedValue: ((c.lastPrice || 0) * (c.volume || 0)) / 100000,
    }));
  }, [contracts]);

  const filteredContracts = useMemo(() => {
    const sorted = [...enrichedContracts];

    if (viewType === "volume") {
      return sorted.sort((a, b) => b.volume - a.volume).slice(0, 10);
    }

    return sorted.sort((a, b) => b.tradedValue - a.tradedValue).slice(0, 10);
  }, [viewType, enrichedContracts]);

  useEffect(() => {
    if (optionData) {
      setLastUpdated(formatTimestamp());
    }
  }, [optionData]);

  // =====================
  // TABLE BODY
  // =====================
  const navigate = useNavigate();

  const handleRefresh = async () => {
    if (loading) return;

    const currentExpiry = selectedExpiry;

    try {
      await fetchByIndex("NIFTY");

      if (currentExpiry) {
        setExpiry(currentExpiry);
      }
    } catch (error) {
      console.error("Failed to refresh active contracts:", error);
    }
  };
  return (
    <>
      <div>
        {/* <div className="last-updated-head">
          {lastUpdated && <span>As on {lastUpdated}</span>}
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div> */}
        <div className="back-btn">
          <button className="rec-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
        <div className="active-contract">
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="active-head">
              <h2>
                Most Active Contracts (
                {viewType === "volume" ? "By Volume" : "By Value"})
              </h2>
            </div>

            <select
              value={viewType}
              onChange={(e) => setViewType(e.target.value)}
              className="select-option dropdown active-contract-dropdown"
            >
              <option value="volume">By Volume</option>
              <option value="value">By Value</option>
            </select>
          </div>
          <div className="last-updated-head">
            {lastUpdated && <span>As on {lastUpdated}</span>}
            <FiRefreshCw
              onClick={handleRefresh}
              size={18}
              style={{
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
              onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
            />
          </div>
        </div>
        <div
          className="stock-table-container active-table"
          style={{ overflowX: "auto" }}
        >
          {/* <div className="active-contract">
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div className="active-head">
                <h2>
                  Most Active Contracts (
                  {viewType === "volume" ? "By Volume" : "By Value"})
                </h2>
              </div>

              <select
                value={viewType}
                onChange={(e) => setViewType(e.target.value)}
                className="select-option dropdown active-contract-dropdown"
              >
                <option value="volume">By Volume</option>
                <option value="value">By Value</option>
              </select>
            </div>

            
          </div> */}

          <table
            className="stock-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th>INSTRUMENT TYPE</th>
                <th>SYMBOL</th>
                <th>EXPIRY DATE</th>
                <th>OPTION TYPE</th>
                <th>STRIKE PRICE</th>
                <th>LTP</th>
                <th>%CHNG</th>
                <th>VOLUME</th>
                <th>VALUE (₹ Lakhs)</th>
                <th>OPEN INTEREST</th>
                <th>UNDERLYING</th>
              </tr>
            </thead>
            {/* <tbody>
              {contracts.map((c, idx) => (
                <tr
                  key={idx}
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <td>Index Options</td>
                  <td>{c.underlying}</td>
                  <td>{c.expiryDate}</td>
                  <td>{c.type === "CE" ? "Call" : "Put"}</td>
                  <td>{c.strikePrice}</td>
                  <td>{c.lastPrice}</td>
                  <td style={{ color: c.pChange > 0 ? "#2fd18a" : "#f87171" }}>
                    {c.pChange.toFixed(2)}
                  </td>
                  <td>{c.totalTradedVolume}</td>
                  <td>{(c.tradedValue / 100000).toFixed(2)}</td>
                  <td>{c.openInterest}</td>
                  <td>{c.underlyingValue}</td>
                </tr>
              ))}
            </tbody> */}
            {/* <tbody>
              {filteredContracts.map((c, idx) => (
                <tr key={idx}>
                  <td>Index Options</td>
                  <td>{c.underlying}</td>
                  <td>{c.expiry}</td>
                  <td>{c.type === "CE" ? "Call" : "Put"}</td>
                  <td>{c.strikePrice}</td>
                  <td>{c.ltp}</td>
                  <td style={{ color: c.pChange > 0 ? "#2fd18a" : "#f87171" }}>
                    {c?.pChange?.toFixed(2)}
                  </td>
                  <td>{c.volume}</td>
                  <td>{c.tradedValue.toFixed(2)}</td>
                  <td>{c.oi}</td>
                  <td>{c.underlyingPrice}</td>
                </tr>
              ))}
            </tbody> */}
            <tbody>
              {filteredContracts.map((c, idx) => (
                <tr key={idx} style={{ textAlign: "center" }}>
                  <td>{c.instrument}</td>

                  <td>{c.underlying}</td>

                  <td>{c.expiry}</td>

                  <td>{c.type === "CE" ? "Call" : "Put"}</td>

                  <td>{c.strikePrice}</td>

                  <td>{c.lastPrice.toFixed(2)}</td>

                  <td style={{ color: c.pChange >= 0 ? "#2fd18a" : "#f87171" }}>
                    {c.pChange.toFixed(2)}%
                  </td>

                  <td>{c.volume.toLocaleString()}</td>

                  <td>{c.tradedValue.toFixed(2)}</td>

                  <td>{c.openInterest.toLocaleString()}</td>

                  <td>{optionData?.data?.last_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ActiveContracts;
